import { useLoad } from "@allergy123/api-client/react";
import { Card, Field, Status, Table, Td, Th } from "@allergy123/ui";
import { useState } from "react";
import { Link } from "react-router";
import { CatalogHeader, errorText } from "./common";

export function AntigensPage() {
  const data = useLoad((a) => a.admin.catalog.antigens());
  const [q, setQ] = useState("");
  const needle = q.trim().toLowerCase();
  const rows = (data.data?.antigens ?? []).filter((a) => `${a.displayName} ${a.abbreviation}`.toLowerCase().includes(needle));
  return (
    <>
      <CatalogHeader title="Antigens" intro="Each allergen once, with its names, classification and the products that supply it. Edits apply immediately and are audited." />
      {data.state === "error" && <Status kind="error" label={`Couldn't load antigens (${errorText(data.error)})`} />}
      <Card>
        <div className="mb-4">
          <Field label="Search" value={q} onChange={(e) => setQ(e.target.value)} hint="Display name or abbreviation" />
        </div>
        <Table caption={data.data ? `${rows.length} of ${data.data.antigens.length} antigens` : "Loading…"}>
          <thead>
            <tr>
              <Th>Name</Th>
              <Th>Abbreviation</Th>
              <Th>Category</Th>
              <Th>Products</Th>
              <Th>Offered</Th>
            </tr>
          </thead>
          <tbody>
            {rows.map((a) => (
              <tr key={a.id}>
                <Td>
                  <Link to={`/catalog/antigens/${a.id}`} className="font-medium text-anchor underline">
                    {a.displayName}
                  </Link>
                </Td>
                <Td>{a.abbreviation}</Td>
                <Td>{a.controlKind ? `control (${a.controlKind})` : a.category}</Td>
                <Td>{a.productCount}</Td>
                <Td>{a.isOffered ? "Yes" : "No"}</Td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Card>
    </>
  );
}
